module.exports = __webpack_public_path__ + "img/hotel9.23a3d7e5.png";